<template>
  <div id="modalContactTicket" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Vincular Contato ao Ticket: {{ ticketId }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <LoadingData v-if="isLoadingData" />
            <div v-else>
              <p><strong>Solicitante:</strong> {{ ticket.requester }}</p>
              <div>
                <label class="form-label">
                  Contato: <span class="text-danger">*</span>
                </label>
                <ModelSelect
                  :options="formatedContacts"
                  :class="[
                    v$.ticket.userContactId.$errors.length ? 'is-invalid' : '',
                  ]"
                  v-model="ticket.userContactId"
                />
                <span
                  v-if="
                    v$.ticket.userContactId.required.$invalid &&
                    v$.ticket.userContactId.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Vincular contato"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Vincular Contato</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'

import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: 'ContactTicketModal',

  props: {
    ticketId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  components: {
    LoadingData,
    ModelSelect,
  },

  data() {
    return {
      isLoadingData: true,
      contacts: [],
      formatedContacts: [],
      ticket: {
        requester: '',
        userContactId: '',
      },
      disableButton: false,
    }
  },

  methods: {
    async getTicket() {
      try {
        this.ticket = await this.$store.dispatch('getTicket', this.ticketId)
        showModal('modalContactTicket')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getContacts() {
      try {
        this.contacts = await this.$store.dispatch('getContacts')

        this.contacts.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })

        this.formatedContacts = this.contacts.map((contact) => ({
          value: contact.id,
          text: `${contact.name} - ${contact.email} ${
            contact.clientId === null ? '(Cliente não registrado)' : ''
          } [${contact.id} / ${contact.userType}]`,
        }))
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true

        try {
          const response = await this.$store.dispatch('updateTicket', {
            ticketId: this.ticketId,
            ticket: this.ticket,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      ticket: {
        userContactId: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getTicket()
    this.getContacts()
  },
}
</script>
